import { render } from "./ProfilePage.vue?vue&type=template&id=f4a1800c"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=f4a1800c&lang=css"
script.render = render

export default script